export default "__VITE_ASSET__lITqJAUO__"